import LegalLayout, { H2, P, UL } from "@/components/legal/LegalLayout";

export default function PrivacyPage() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Privacy Policy"
      updated="January 20, 2026"
      testid="privacy-page"
    >
      <P>
        This Privacy Policy explains how BlockNexa Labs ("we", "us") collects, uses, and protects
        information when you visit Qovarix, join the closed beta waitlist, or read our
        documentation. We collect only the minimum data needed to operate the Service.
      </P>

      <H2>1. Information We Collect</H2>
      <UL>
        <li>
          <strong className="text-white">Waitlist data:</strong> the email address and optional name
          you provide when requesting closed beta access.
        </li>
        <li>
          <strong className="text-white">Technical data:</strong> standard server logs (IP address,
          user agent, timestamps) used to keep the Service secure and reliable.
        </li>
        <li>
          <strong className="text-white">On-chain data:</strong> when you interact with the Qovarix
          protocol, your wallet address and transactions are visible on the public blockchain. This
          is a property of the blockchain itself, not data we collect.
        </li>
      </UL>

      <H2>2. How We Use Information</H2>
      <UL>
        <li>To notify waitlist members about closed beta availability and onboarding steps.</li>
        <li>To operate, secure, and improve the Service.</li>
        <li>To communicate important product, legal, or security updates.</li>
      </UL>

      <H2>3. Legal Basis</H2>
      <P>
        Where applicable law requires a legal basis, we rely on your consent (submitting the
        waitlist form) and our legitimate interest in operating a secure Service.
      </P>

      <H2>4. Data Retention</H2>
      <P>
        Waitlist emails are retained until you request deletion or until the closed beta program
        ends and retention is no longer necessary. Server logs are retained for a limited period for
        security and debugging purposes.
      </P>

      <H2>5. Sharing</H2>
      <P>
        We do not sell your personal information. We may share data with trusted infrastructure
        providers (e.g. hosting, email delivery) strictly to operate the Service. We may disclose
        information where required by law.
      </P>

      <H2>6. Your Rights</H2>
      <P>
        Depending on your jurisdiction, you may have the right to access, correct, or delete your
        data, to object to processing, and to withdraw consent. To exercise these rights, email{" "}
        <a href="mailto:contact@blocknexalabs.com" className="text-[#00F0FF] hover:underline">
          contact@blocknexalabs.com
        </a>
        .
      </P>

      <H2>7. Security</H2>
      <P>
        We apply reasonable technical and organizational safeguards to protect data in transit and
        at rest. No system is perfectly secure — if you suspect your data has been compromised,
        please contact us immediately.
      </P>

      <H2>8. Children</H2>
      <P>
        Qovarix is not directed at children under 18 and we do not knowingly collect data from them.
      </P>

      <H2>9. Changes</H2>
      <P>
        We may update this Privacy Policy from time to time. Material changes will be reflected in
        the "Last updated" date above.
      </P>
    </LegalLayout>
  );
}
